import { render, staticRenderFns } from "./CustomerTab.vue?vue&type=template&id=4329da38&"
import script from "./CustomerTab.vue?vue&type=script&lang=js&"
export * from "./CustomerTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTab.vue?vue&type=style&index=0&id=4329da38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports